module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_5010.3d8f8740.png";